import React from 'react'
import {
    Box,
    Button,
    FormControl,
    TextField,
    Typography,
    Grid
} from "@mui/material";
import { useUnsubscribeClausesMutation } from '../../services/clausesService'
import { useSearchParams } from 'react-router-dom';
import { useToasts } from '../../hooks/useToasts'
import toast from "react-hot-toast"
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { useState } from 'react';

const ClauseUnubscribePage = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const personLeadId = searchParams.get("lead");
    const [clauseIsSubscribed, setClauseIsSubscribed] = useState(false)
    const { onFormErrors, onServerError } = useToasts();
    const { mutate: setsubsctibeClauses, isPending } = useUnsubscribeClausesMutation({
        onSuccess: (data, variables, context) => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyEditedClause")} />,
                {
                    position: "bottom-right",
                },
            );
            setClauseIsSubscribed(true)
        },
        onError: (error) => {
            onServerError(error);
        },
    });

    const onSubmit = () => {
        setsubsctibeClauses({
            personLeadId,
        })
    };
  
  return <>
        {clauseIsSubscribed && 
                <Typography color="primary" variant="h6">
                    {"Odsubscrybowano"}
                </Typography>
        }
        {!clauseIsSubscribed && <Grid container>
            <Grid item xs={12}>
                <Typography 
                color="primary" variant="h6"
                >
                    {"Czy na pewno chcesz odsubscrybować?"}
                </Typography>
            </Grid>
            <Grid
                item 
                xs={12}
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs={6} textAlign={"right"}>
                    <LoadingButton
                        style={{ minWidth: "100px" }}
                        variant="contained"
                        size="small"
                        onClick={onSubmit}
                        color={"success"}
                        loading={isPending}
                        disabled={isPending}
                    >
                        {t("true")}
                    </LoadingButton>
                </Grid>
                <Grid item xs={6} textAlign={"left"}>
                    <Button
                        color={"error"}
                        style={{ minWidth: "100px" }}
                        variant="contained"
                        size="small"
                        onClick={()=>{}}
                        disabled={isPending}
                    >
                        {t("false")}
                    </Button>
                </Grid>
            </Grid>
        </Grid>}
        </>
}

export default ClauseUnubscribePage